import { Brand, Container, MenuTopBar, MyVfPfLabel, Navbar, NavbarBrand } from '@vfpf/vfpf-shared';
import React from 'react';
import { LogoutDropdown } from './LogoutDropdown';

export const Header: React.FC = () => {
  return (
    <header>
      <>
        <MenuTopBar
          variant="ssa"
          leftColComponent={<MyVfPfLabel variant="ssa" />}
          rightColComponent={<LogoutDropdown />}
        />
        <Navbar variant={'ssa'}>
          <Container>
            <NavbarBrand>
              <Brand variant={'ssa'} />
            </NavbarBrand>
          </Container>
        </Navbar>
      </>
    </header>
  );
};
